/**
 * TestIcon/index.js
 * desc: system icon for test step type
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const TestIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="test icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.test.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg"><path d="M18.55 17.187L12 6.862V1.667h.834a.8.8 0 00.586-.248.8.8 0 00.247-.586.8.8 0 00-.247-.586.8.8 0 00-.586-.247H6.167a.8.8 0 00-.586.247.8.8 0 00-.247.586.8.8 0 00.247.586c.165.165.36.248.586.248h.834v5.195L.45 17.187c-.486.773-.58 1.435-.28 1.986.3.551.91.827 1.83.827h15c.92 0 1.53-.276 1.83-.827.299-.55.205-1.213-.28-1.986zM4.865 13.333l3.542-5.586.26-.403V1.667h1.667v5.677l.26.403 3.542 5.586h-9.27z"/></svg>
    </IconButton>
);


export default TestIcon;
